var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{ref:"expertcanvas",staticClass:"editor",attrs:{"width":"700","height":"500"}})])}
var staticRenderFns = []

export { render, staticRenderFns }